import { FilterCategoryTabProps } from 'types/ProductType';
import React, { useState, useEffect } from 'react';
import DraggableScrollContainer from '../Drag/DraggableScrollContainer';
import IconCommon from '../Icon/IconCommon';
import { icon_ton, sat_vuong, icon_vlxd } from 'utils/importFile';

const FilterCategoryTab: React.FC<FilterCategoryTabProps> = ({
  categories,
  selectedCategoryId,
  onSelectCategory,
  allQuantity,
  setFilterCategorys,
  className = '',
}) => {
  const [tempAllQuantity, setTempAllQuantity] = useState(allQuantity);

  useEffect(() => {
    if (allQuantity > tempAllQuantity) setTempAllQuantity(allQuantity);
  }, [allQuantity]);

  const getCategoryIcon = (name: string) => {
    const lower = name.toLowerCase();
    if (lower.includes('tôn')) return <IconCommon src={icon_ton} className='mr-2' height={100} />;
    if (lower.includes('thép')) return <IconCommon src={sat_vuong} className='mr-2' />;
    if (lower.includes('sắt')) return <IconCommon src={sat_vuong} className='mr-2' />;
    return <IconCommon src={icon_vlxd} className='mr-2' />;
    return null;
  };

  const sortedCategories = React.useMemo(() => {
    const filterCategories = categories.filter((c) => c?.productCount && c?.productCount > 0);
    const ton = filterCategories.filter((c) => c.name.toLowerCase().includes('tôn'));
    const thep = filterCategories.filter((c) => c.name.toLowerCase().includes('thép'));
    const sat = filterCategories.filter((c) => c.name.toLowerCase().includes('sắt'));
    console.log(sat);
    const others = filterCategories.filter(
      (c) =>
        !c.name.toLowerCase().includes('tôn') &&
        !c.name.toLowerCase().includes('thép') &&
        !c.name.toLowerCase().includes('sắt'),
    );
    return [...ton, ...thep, ...sat, ...others];
  }, [categories]);

  return (
    <div className={className}>
      <DraggableScrollContainer>
        <div
          className='grid gap-3 py-3 scrollbar-hide'
          style={{
            display: 'grid',
            gridAutoFlow: 'column',
            gridTemplateRows: 'repeat(3, auto)',
            gridAutoColumns: 'max-content',
          }}
        >
          <div
            onClick={() => {
              onSelectCategory(null);
              setFilterCategorys([]);
            }}
            className={`rounded-lg min-w-[140px] min-h-[40px] cursor-pointer px-3 py-2 flex items-center shadow-lg ${
              selectedCategoryId === null ? 'bg-[var(--primaryColor500)] text-white' : 'bg-white text-black'
            }`}
          >
            <h3 className='text-base font-bold'>Tất cả ({tempAllQuantity})</h3>
          </div>

          {sortedCategories.map((category, index) => {
            const isSelected = selectedCategoryId === category.id;
            return (
              <div
                key={index}
                onClick={() => {
                  onSelectCategory(category.id);
                  setFilterCategorys([]);
                }}
                className={`rounded-lg min-w-[140px] min-h-[40px] cursor-pointer px-3 py-2 flex items-center shadow-lg ${
                  isSelected ? 'bg-[var(--primaryColor500)] text-white' : 'bg-white text-black'
                }`}
              >
                {getCategoryIcon(category.name)}
                <h3 className='text-base font-bold line-clamp-1'>
                  {category.name} ({category.productCount})
                </h3>
              </div>
            );
          })}
        </div>
      </DraggableScrollContainer>
    </div>
  );
};

export default FilterCategoryTab;
